import { Box } from "@mantine/core";
import { Outlet } from "react-router-dom";
import Footer from "../../components/Footer";
import TopNavbarBda from "../../components/NavigationBar/TopNavbarBda";

const BdaLayout = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <TopNavbarBda />
      <Outlet />
      <Footer />
    </Box>
  );
};
export default BdaLayout;
